"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
require("../scss/GlobalDesignLegacy.scss");
require("../../node_modules/bootstrap-icons/font/bootstrap-icons.scss");
window.gs1 = {};
TYPO3.lang = TYPO3.lang || {};
TYPO3.settings = TYPO3.settings || {};
require("./modules/GlobalDesignForms/orderForm");
require("./modules/GlobalDesignForms/metrics");
require("./modules/GlobalDesignForms/udiOrderForm");
require("./modules/GlobalDesignForms/dqx");
require("./modules/GlobalDesignForms/c4l");
require("./modules/GlobalDesignForms/vbg");
require("./modules/GlobalDesignForms/certificateOrder");
require("./modules/GlobalDesignForms/upgradeOrder");
